import { useEffect } from 'react'
import { useScreenSize } from 'src/customHooks/customHooks'
import TimerClock from '../TimerClock'
import { TimerDigitsContainer } from '../styledComponents'

export default function RangeTimer({
  minDuration,
  maxDuration,
  timerSeconds,
  backgroundImg,
  playStartTimerSound,
  totalIntervals,
  intervalsLeft,
}) {
  const durationToUse = minDuration
  const timeLeft = durationToUse / 1000 - timerSeconds
  const timeInPositive = timeLeft > 0 ? timeLeft : -timeLeft

  const secondsLeft = Math.floor(timeInPositive % 60)
  const minutesLeft = Math.floor((timeInPositive / 60) % 60)
  const { width } = useScreenSize()

  useEffect(() => {
    if (timerSeconds === minDuration / 1000) {
      playStartTimerSound(true)
    }
    if (timerSeconds === maxDuration / 1000) {
      playStartTimerSound(true)
    }
  }, [timerSeconds])

  return (
    <TimerClock
      timerSeconds={timerSeconds}
      backgroundImg={backgroundImg}
      topPadding={width > 768 ? '52px' : '16px'}
      totalIntervals={totalIntervals}
      intervalsLeft={intervalsLeft}
    >
      <TimerDigitsContainer className="small-text">
        {timeLeft > 0 ? ' - ' : ' + '}
        {String(minutesLeft).padStart(2, '0')}:{String(secondsLeft).padStart(2, '0')}
      </TimerDigitsContainer>
    </TimerClock>
  )
}
